import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { PhoneInput } from "../common/PhoneInput";
import { Country } from "react-phone-number-input";

interface ControlledPhoneInputProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  placeholder?: string;
  defaultCountry?: Country;
  label?: string;
  error?: string;
  disabled?: boolean;
}

const ControlledPhoneInput = <T extends FieldValues>({
  control,
  name,
  placeholder,
  label,
  defaultCountry,
  error,
  disabled,
}: ControlledPhoneInputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <PhoneInput
          {...field}
          placeholder={placeholder}
          defaultCountry={defaultCountry}
          international
          label={label}
          error={error}
          disabled={disabled}
          className="w-full h-full"
        />
      )}
    />
  );
};

export { ControlledPhoneInput };
